/**
 * The cover video of every masterclass, by module key, for surfaces that
 * show a masterclass without loading it.
 *
 * The shelf builds its cover from the module itself (coverArt.js:
 * mod.coverVideoId, rendered as a Mux frame). The home page's notice card
 * shows masterclasses too, and importing every module into the dashboard to
 * read one field each would put every masterclass's full text in the home
 * page bundle. So the field is copied here, and masterclassCovers.test.js
 * fails, naming the key, the moment a module's cover and this map disagree.
 *
 * Without it the card fell back to the generated SVGs, the same gold grid
 * eleven times over, which is what coverArt.js was written to get rid of.
 */
import { coverSources } from "./coverArt";
export const MASTERCLASS_COVERS = {
  "aau-dev-first": "TME1jfd6Oi9Uu0002GItMGISablcwEQo00dGSAXErUsZ018",
  "building-high-quality-movers": "TOratbvph02TUMzzwBEKa53SSaJyuq8kGg02Gk00jSA01l00",
  "differential-learning": "hKje1T02lUzKP1iDI3GkgaJW01wcVADNMxEvWzucf957Y",
  "four-foundational-concepts": "5QE02HoCcX87YClW4LbFonsaLMsNoZiXpkbdlt3G334o",
  "games-approach-overview": "1shqfM5W00VaG4D6dfV4n01MM2glmkje01ohKi6Eb00nZGA",
  "important-definitions-part-1": "U39vw00JRKsMUDfAcKPBLc5RD4xC00F4GvIupBRtWairk",
  "important-definitions-part-2": "BIJykRju1Cxt9m9GEhmwRN6hSkavxliBbkRhm1APKXA",
  "internal-external-cues": "02ctdysdyPWGhEEbzMS01wgm7kqfJwSVEDuq8fgghfz8I",
  "let-the-task-teach": "YBOifHwH8kfeHVydZpa01enMFB02vYYDaqAkp01MD1oFoM",
  "how-humans-learn-motor-skills": "qOYS55cTCjTc3b02Iul00tWwVOLJiaQZUYo2pxW02IT8W8",
  "nba-player-development": "FHQl2KTynWkFCwRIoxzzBRtxH8qVK8DYDNtu17vYXgw",
  "passing-accuracy": "WbpckQm00d7iUEfCix5Bk00fcrLLqHPyEWcXSOednY01lw",
  "modern-point-guard": "002AQ01mSaGZ8QeF00uIx6Cl01iBANSnf1srD5bCsW7BS5o",
  "psychological-skills": "UVfezzZjVnoISKvfd6KWGR7sfozhfJnwdiLupa9PSRc",
  "research-1v1-shooting": "hoWhd1ggWJfVZ1jRgjRC02cOLHGnIFetatPTs71nsR1Q",
  "rikki-broadmore-clinic": "O72XF02yreOx6G35D6ryBi6LNtyh01Fk02e2cuxyPfcPas",
  "science-in-practice": "HL7E6IbMKedprWqdYc623iVe63KQXpzUEpC7naSIZTc",
  "building-better-shooters": "JrW00o6A5Dr2YsXj7D02Z25GYGYH9vuFUjejBbwKHYgTM",
  "simplifying-the-science": "oH4cTcGDxDetPYYxQESs3Z7KLuWgoIP00ET8iidOsAE8",
  "teaching-shooting-skill-acquisition": "02xXxVqv4IW00CUqsD19YCvnCGQO01Mu29h8hGWcpmCgt8",
  "truths-of-coaching": "O9kKq2bDdiOjz73nwYw1iohO1AQ8WE8MD2ir5k027sj00",
  "rethinking-the-warmup": "6PcYC00XPFU6QJnhLdpOAtd2nZJAHbLRa45hZpXZD33Y",
  "two-feet-on-the-move": "HXXVMcP5pxlIJwATaS86z025h00gCPSRsRXB9UodNdYIg",
};

/**
 * Cover candidates for a shelf item, best first: a hand-picked poster, then
 * a frame of its own video. The generated SVG, the shelf's last resort, is
 * left off: a card with no picture reads better than one with the gold grid.
 */
export function masterclassCover(item) {
  if (!item) return [];
  return coverSources(item, { coverVideoId: MASTERCLASS_COVERS[item.moduleKey] }, { width: 640, height: 360 })
    .filter(src => !/\.svg($|\?)/.test(src));
}
